export const ASSISTANT_EXPANSION_MS = 620;

// Animar el tamaño real evita estirar las letras y los iconos del chat.
export function assistantExpansionFrames(from, to) {
  return [
    { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px`, borderRadius: "12px" },
    { left: `${to.left}px`, top: "0px", width: `${to.width}px`, height: `${to.height}px`, borderRadius: "0px" },
  ];
}
